export default __webpack_public_path__ + "static/media/icon-social-comment.b683890a.svg";